import Card from './card';
import List from './list';
import Breakdown from './breakdown';
const Transaction = {};
Transaction.Card = Card;
Transaction.List = List;
Transaction.Breakdown = Breakdown;
export default Transaction;
//# sourceMappingURL=index.js.map